<div class="flex flex-col">
  <div class="flex flex-row p-2 gap-5">
    <p-avatar
      [label]="authService.currentUser?.getAvatarLetters()"
      shape="circle"
      size="large"
      styleClass="oskaru-gradient text-white"
    />
    <div>
      <div class="font-bold mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
        {{ authService.currentUser?.firstName }}
        {{ authService.currentUser?.lastName }}
      </div>
      <div class="text-sm whitespace-nowrap overflow-hidden text-ellipsis">
        {{ authService.currentUser?.username }}
      </div>

      <div class="mt-2 text-sm">
        @for (role of userRoles; track role) {
          <p-tag [value]="role" severity="secondary" class="m-1"/>
        }
      </div>
    </div>
  </div>
  <p-divider></p-divider>
  <div>
    <div class="mb-2">Change theme:</div>
    <app-theme-select-button [showLabel]="true"></app-theme-select-button>
  </div>
  <p-divider></p-divider>
  <div class="flex justify-end">
    <p-button
      id="logoutBtn"
      label="Logout"
      icon="pi pi-sign-out"
      (click)="onClickLogout()"
      [text]="false"
      severity="secondary"
      [outlined]="true"
      styleClass=""
    ></p-button>
  </div>
</div>
